import styles from '../Inicio/Inicio.module.css';
import { ROUTES } from '../../const/routes';
import { useNavigate } from 'react-router-dom';
import BannerLogo from '../../components/BannerLogo/BannerLogo';
import ImagenTragamonedasInicio from '../../components/ImagenTragamonedasInicio/ImagenTragamonedasInicio';
import BotonGrandeDinamico from '../../components/Botones/BotonGrandeDinamico/BotonGrandeDinamico';
import Footer from '../../components/Footer/Footer';
import { useTranslation } from 'react-i18next';

const QueCasinoPrint = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className={'flex flex-col min-h-screen ' + styles.inicioContainer}>
      <div className="flex flex-col flex-grow items-center justify-between text-center px-4">
        <BannerLogo />
        <div className="flex flex-col lg:flex-row justify-center items-center lg:items-end w-full max-w-5xl gap-4 lg:gap-8 mb-4">
          <div className="w-full lg:w-auto flex justify-center order-1 lg:order-1">
            <ImagenTragamonedasInicio />
          </div>
          <div
            className="p-5 lg:p-6 w-full max-w-md lg:max-w-xl space-y-3 flex flex-col bg-bgContenedorOscuro 
          rounded-lg border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-[0_0_30px_rgba(100,116,139,0.9)]
          transition-all duration-300 ease-in-out hover:shadow-[0_0_40px_rgba(100,116,139,1)] order-2 lg:order-2"
          >
            <h2 className="text-xl text-yellow-500 font-bold mb-2">
              {t('about.title')}
            </h2>
            <p className="text-sm text-gray-300 mb-2 text-left leading-relaxed">
              {t('about.intro1')}{' '}
              <span className="text-yellow-500 font-semibold">
                {t('about.tudw')}
              </span>{' '}
              {t('about.unco')}
            </p>
            <p className="text-sm text-gray-300 mb-2 text-left leading-relaxed">
              {t('about.purpose1')}{' '}
              <span className="text-yellow-500 font-semibold">
                {t('about.purpose2')}
              </span>
              , {t('about.balance1')}{' '}
              <span className="text-yellow-500 font-semibold">{t('about.balance2')}</span>{' '}
              {t('about.balance3')}
            </p>
            <p className="text-sm text-gray-300 mb-2 text-left leading-relaxed">
              {t('about.ranking1')}{' '}
              <span className="text-yellow-500 font-semibold">{t('about.ranking2')}</span>{' '}
              {t('about.ranking3')}
            </p>
            <p className="text-sm text-gray-300 mb-2 text-left leading-relaxed">
              {t('about.mercadopago1')}{' '}
              <span className="text-yellow-500 font-semibold">{t('about.mercadopago2')}</span>{' '}
              {t('about.mercadopago3')}{' '}
              <span className="text-yellow-500 font-semibold">
                {t('about.testAccounts1')}
              </span>{' '}
              {t('about.testAccounts2')}
            </p>
            <div className="pt-2 space-y-3">
              <BotonGrandeDinamico
                texto={t('about.loginButton')}
                bgColor="blue"
                direccion={ROUTES.login}
              />
              <BotonGrandeDinamico
                texto={t('about.registerButton')}
                bgColor="pink"
                direccion={ROUTES.register}
              />
              <button
                onClick={() => navigate(ROUTES.inicio)}
                className="text-blue-400 hover:underline text-sm"
              >
                {t('about.backToHome')}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};

export default QueCasinoPrint;
